// extracted by mini-css-extract-plugin
module.exports = {"counting-box":"_2O7rkVAKhjfnAtEdhZD-1d"};